<div id="form-container">
  <form
    [formGroup]="userForm"
    id="user-form"
    class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8"
    (ngSubmit)="onSubmit()" >
    <h3 class="ui-heading-3-bold">{{ selectedUser?.unixID ? 'User' : 'Add User' }}</h3>
    <div id="editable">
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Email</rds-control-label>
        <input rdsInput formControlName="email" />
      </rds-form-field>

      @if (selectedUser?.unixID) {
        <rds-form-field labelPosition="side-left">
          <rds-control-label>Username</rds-control-label>
          <input rdsInput formControlName="unixID" />
        </rds-form-field>
      }

      <div id="Role">
        <section id="role-section" class="list">
          <p id="role-header" class="rds-form-field__label list-label">
            Role<span class="c-error">*</span>
          </p>
          <div id="role-content">
            <rds-radio-group class="d-flex flex-row gap-5" formControlName="roleID">
              <rds-radio-button [value]="1" data-testid="role-1">View Only</rds-radio-button>
              <rds-radio-button [value]="2" data-testid="role-2">Editor</rds-radio-button>
              <rds-radio-button [value]="3" data-testid="role-3">Admin</rds-radio-button>
            </rds-radio-group>
          </div>
        </section>
      </div>
    </div>

    <div id="controls" rds-drawer-actions>
      @if (selectedUser !== null && selectedUser.unixID !== undefined) {
        <button rds-secondary-warning-button type="button" (click)="onDelete()">Delete</button>
      }
      <button rds-primary-button type="submit" class="ms-auto" [disabled]="isLoadingChanges">
        @if(!isLoadingChanges){
          {{selectedUser !== null && selectedUser.unixID ? 'Update' : 'Add'}}
        }
        @else{
        <rds-progress-spinner label="Saving User..." size="m" white></rds-progress-spinner>
      }
    </button>
  </div>
</form>
</div>
